import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader1 from '../../components/common/PageHeader1';
import apiClient from "../../utils/api";
import { toast } from 'react-toastify';

function ChargesAdd() {
    const navigate = useNavigate();    
    const [exitLocations, setExitLocations] = useState([]);
    const [formData, setFormData] = useState({
        parking_type: '',
        rate_type: 'flat',
        exit_location_id: '',
        rate_per_hour: '',
        hourly_rates: {
            '1': '',
            '2': '',
            '3': '',
            '4': '',
            '5': ''
        },
        grace_period: '',
        minimum_fee: '',
        maximum_fee: '',
        effective_from: '',
        is_active: true
    });

    const [loading, setLoading] = useState(false);    
    const fetchExitLocations = async () => {
        try {
            const token = localStorage.getItem('auth_token');
            const response = await apiClient.get('accounts/exit-locations', {
                headers: { Authorization: `Bearer ${token}` }
            });
            setExitLocations(response.data.data);
        } catch (error) {
            console.error('Error:', error);
            toast.error('Failed to load Valet Locations');
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name.startsWith('hour_')) {
            const hour = name.split('_')[1];
            setFormData(prev => ({
                ...prev,
                hourly_rates: {
                    ...prev.hourly_rates,
                    [hour]: value
                }
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };    useEffect(() => {
        fetchExitLocations();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const token = localStorage.getItem('auth_token');
            const postData = {
                ...formData,
                hourly_rates: formData.rate_type === 'hourly' ? JSON.stringify(formData.hourly_rates) : null,
                rate_per_hour: formData.rate_type === 'flat' ? formData.rate_per_hour : null
            };

            await apiClient.post('accounts/charges', postData, {
                headers: { Authorization: `Bearer ${token}` }
            });
            
            toast.success('Service charges added successfully');
            navigate('/accounts/charges-list');
        } catch (error) {
            console.error('Error:', error);
            toast.error(error.response?.data?.message || 'Failed to add service charges');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container-xxl">
            <PageHeader1 pagetitle="Add Charges Adjustement" />
            <div className="row g-3">
                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-body">
                            <form onSubmit={handleSubmit}>
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <label className="form-label">Service Type</label>
                                        <select
                                            className="form-select"
                                            name="parking_type"
                                            value={formData.parking_type}
                                            onChange={handleInputChange}
                                            required
                                        >
                                            <option value="">Select Type</option>
                                            <option value="VIP">VIP</option>
                                            <option value="Normal">Normal</option>
                                            <option value="Complementary">Complementary Service</option>
                                        </select>
                                    </div>

                                    <div className="col-md-6">
                                        <label className="form-label">Rate Type</label>
                                        <select
                                            className="form-select"
                                            name="rate_type"
                                            value={formData.rate_type}
                                            onChange={handleInputChange}
                                            required
                                        >
                                            <option value="flat">Flat Rate</option>
                                            <option value="hourly">Hourly Rate</option>
                                        </select>
                                    </div>                                    <div className="col-md-12">
                                        <label className="form-label">Valet Location</label>
                                        <select
                                            className="form-select"
                                            name="exit_location_id"
                                            value={formData.exit_location_id}
                                            onChange={handleInputChange}
                                            required
                                        >
                                            <option value="">Select Valet Location</option>
                                            {exitLocations.map(location => (
                                                <option key={location.id} value={location.id}>
                                                    {location.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {formData.rate_type === 'flat' ? (
                                        <div className="col-md-6">
                                            <label className="form-label">Rate per Hour</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="rate_per_hour"
                                                value={formData.rate_per_hour}
                                                onChange={handleInputChange}
                                                step="0.01"
                                                required
                                            />
                                        </div>
                                    ) : (
                                        <>
                                            <div className="col-12">
                                                <label className="form-label">Hourly Rates</label>
                                            </div>
                                            {[1, 2, 3, 4, 5].map(hour => (
                                                <div className="col-md-4" key={hour}>
                                                    <label className="form-label">{hour} Hour</label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        name={`hour_${hour}`}
                                                        value={formData.hourly_rates[hour]}
                                                        onChange={handleInputChange}
                                                        step="0.01"
                                                        required
                                                    />
                                                </div>
                                            ))}
                                        </>
                                    )}

                                    <div className="col-md-6">
                                        <label className="form-label">Grace Period (Minutes)</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="grace_period"
                                            value={formData.grace_period}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <label className="form-label">Minimum Fee</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="minimum_fee"
                                            value={formData.minimum_fee}
                                            onChange={handleInputChange}
                                            step="0.01"
                                            required
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <label className="form-label">Maximum Fee</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="maximum_fee"
                                            value={formData.maximum_fee}
                                            onChange={handleInputChange}
                                            step="0.01"
                                            required
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <label className="form-label">Effective From</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="effective_from"
                                            value={formData.effective_from}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="mt-3">
                                    <button 
                                        type="submit" 
                                        className="btn btn-primary"
                                        disabled={loading}
                                    >
                                        {loading ? 'Adding...' : 'Add Rule'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ChargesAdd;